import { STRIPE_PAYMENT_LINK } from "../config/stripe";

/**
 * Redirects user to Stripe Checkout to purchase Party Pass
 */
export function initiatePartyPassPurchase() {

  // Get current user info to pass to Stripe
  const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
  const authToken = localStorage.getItem("authToken");

  if (!authUser || !authToken) {
    console.error("User not authenticated");
    return;
  }

  // Store purchase intent in localStorage to track when user returns
  localStorage.setItem("partyPassPurchaseIntent", JSON.stringify({
    timestamp: new Date().getTime(),
    userId: authUser.phone_no,
  }));

  // Redirect to Stripe Payment Link
  // Note: You can append query parameters to pre-fill customer email if needed
  const paymentUrl = STRIPE_PAYMENT_LINK;

  if (paymentUrl === "YOUR_STRIPE_PAYMENT_LINK_HERE") {
    console.warn("Stripe Payment Link not configured. Please update src/config/stripe.js");
    alert("Party Pass checkout is not configured yet. Please contact support.");
    return;
  }

  window.location.href = paymentUrl;
}

/**
 * Checks if user has an active Party Pass
 * @returns {boolean}
 */
export function hasActivePartyPass() {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
  return authUser?.zebra_id !== null && authUser?.zebra_id !== undefined;
}
